/**
 * 캐릭터
 */
import { Fragment } from 'react';
import { CUR_NETWORK, PROFILE_IMG_DOMAIN } from '@constants/index';
import { strReplaceUrl } from '@utils/index';
import type { ICharacterBns, ISetCharacterBns, l10nType } from '@type/index';

const setCharacterBnsItem = (item: ICharacterBns): ISetCharacterBns | null => {
  return item && typeof item === 'object'
    ? {
        ...item,
        url: `/world/character/LIVE/${item?.serverId}/${strReplaceUrl(item?.name)}`,
        thumbnailUrl: new URL(item?.profileImageUrl, PROFILE_IMG_DOMAIN[CUR_NETWORK])?.toString(),
        level1: `Lv. ${item?.level}`,
        level2: item?.masteryLevel > 0 ? `홍문 ${item.masteryLevel}성` : '',
      }
    : null;
};

const CharacterBnsArticle = ({ item, l10n }: { item: ICharacterBns; l10n: l10nType }) => {
  const data = setCharacterBnsItem(item);

  if (!data) {
    return <Fragment />;
  }

  const { url, thumbnailUrl, name, className, serverName, level1, level2 } = data;
  return (
    <div className="search-item-content">
      <div className="search-item-thumbnail">
        <a href={url}>
          <img src={thumbnailUrl} alt="캐릭터프로필이미지" />
        </a>
      </div>
      <div className="search-item-article">
        <div className="search-item-title">
          <a href={url} dangerouslySetInnerHTML={{ __html: name }}></a>
        </div>
        <div className="search-item-info">
          <span className="class">{className}</span>
          <span>{serverName}</span>
          <span>{level1}</span>
          {level2 ? <span>{level2}</span> : <Fragment />}
        </div>
      </div>
    </div>
  );
};

export default CharacterBnsArticle;
